const hostname = window.location.hostname
let isRenShe
const reg = (/^[A-Za-z0-9_]+.jiafu.ethrss.cn*/).test(window.location.hostname);
if(hostname.includes('channel') || reg){//机构
    isRenShe = false
}else{//平台
    isRenShe = true
}
export default  isRenShe